/* eslint-disable import/prefer-default-export */
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { yellow, grey } from '@mui/material/colors';

export const LoginTextField = styled(TextField)({
    '& label': {
        color: grey[50],
    },
    '& input': {
        color: grey[50],
    },
    '& label.Mui-focused': {
        color: grey[50],
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: grey[50],
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: grey[50],
        },
        '&:hover fieldset': {
            borderColor: yellow[900],
        },
        '&.Mui-focused fieldset': {
            borderColor: grey[50],
        },
    },
});
